import { supabase } from '@/lib/integrations/supabase'
import type { MovementType } from './movementsTypes'

export async function getMovementTypeByKey(
  contextKey: string,
  key: string
): Promise<MovementType> {
  const { data, error } = await supabase
    .from('movement_types')
    .select('*')
    .eq('context_key', contextKey)
    .eq('key', key)
    .eq('active', true)
    .single()

  if (error) throw error
  if (!data) throw new Error(`Movement type not found: ${contextKey}.${key}`)

  return data
}
